import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { MainContainer } from "../../components"
import { apiRoute, linksUrl } from "../../constants/enum"
import {
  Card,
  CardBody,
  CardFooter,
  Button,
  Select,
  SelectItem,
} from "@nextui-org/react"
import { useEdit, useFetchWithBody } from "../../api/reactQueryCustomHooks"

function EditAppClientMapping() {
  const navigate = useNavigate()
  const { selectedClient } = useSelector((state) => state.clientMaster)
  const { selectedAppClient } = useSelector((state) => state.appClientMapping)

  const [errors, setErrors] = useState({})

  const { data: remaingAppClient = [] } = useFetchWithBody({
    url: apiRoute.appClientMapping.read,
    queryKey: "remaingAppClient",
    inputData: {
      client_code: selectedClient.client_code,
      appId: null,
      option: 2,
    },
  })

  const [formData, setFormData] = useState({
    appId: selectedAppClient.AppId,
  })

  const onClickPrevPage = () => {
    navigate(linksUrl.appClientMapping.read)
  }

  const onSuccessTasks = () => {
    navigate(linksUrl.appClientMapping.read)
  }
  const resetValues = () => {}

  const { isPending, mutate: editAppClientMapping } = useEdit({
    url: apiRoute.appClientMapping.edit,
    queryKey: "AppClientMapping",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleSelect = (e) => {
    setFormData((prev) => ({
      ...prev,
      appId: e.target.value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}
    // Validate AppId
    if (formData.appId.toString().trim() === "") {
      newErrors.appId = "App is required"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      // Perform form submission logic here

      editAppClientMapping({
        data: {
          appId: formData.appId,
          client_code: selectedClient.client_code,
          id: selectedAppClient.Id,
        },
      })
    } else {
      console.log(errors, "errors")
    }
  }

  return (
    <MainContainer
      breadcrumbs={["Client Master", "App", "Edit"]}
      pageName={"Edit Client App"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
      info={[
        ["Client", selectedClient.client_name, selectedClient.client_code],
      ]}
    >
      <Card className="max-w-[600px]" shadow="none" classNames="p-0">
        <form onSubmit={handleSubmit}>
          <CardBody className="p-0">
            <div className="flex flex-col gap-4 mx-2">
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Select
                  label="App Name"
                  placeholder="Select a App"
                  className="max-w-xs"
                  onChange={handleSelect}
                >
                  {remaingAppClient?.map((row) => (
                    <SelectItem key={row?.AppId} value={row?.AppId}>
                      {row?.AppName}
                    </SelectItem>
                  ))}
                </Select>
              </div>
            </div>
          </CardBody>
          <CardFooter>
            <Button color="primary" type="submit" isLoading={isPending}>
              Edit Client App
            </Button>
          </CardFooter>
        </form>
      </Card>
    </MainContainer>
  )
}

export default EditAppClientMapping
